import { Mapper } from './interfaces';

export default function composeResponseMappers<P, R, T>(
  first: Mapper<P, R>,
  second: Mapper<R, T>
): Mapper<P, T> {
  return resp => second(first(resp));
}
